import { Component } from '@angular/core';

@Component({
  selector: 'awp-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';
}
